/**透出端状态
 * 1. APP
 * 2. 微信小程序
 * 3. 所有
 */
export default {
  PENETRATE_APP: "1",
  PENETRATE_APPLET: "2",
  PENETRATE_ALL: "3"
}